import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { Field } from 'formik'
import { DebouncedTextField } from '@user/components/Formik'
import {
  addLeadFirstName,
  addLeadLastName,
  addLeadCompany,
} from '@user/components/Settings/EntityFormSettings'
import type { FieldSettingsMap } from '@user/store/entityFormSettings'
import Grid from '@mui/material/Grid'
import { FormSection } from '@sales-center/components'

interface Props {
  disabled?: boolean
  settingsMap: FieldSettingsMap
  spacing?: number
}

const LeadInformation: React.FC<Props> = ({
  disabled,
  settingsMap,
  spacing,
}) => {
  const [requiredFirstName, showFirstName] = settingsMap.get(
    addLeadFirstName,
  ) ?? [false, true]

  const [requiredLastName, showLastName] = settingsMap.get(addLeadLastName) ?? [
    false,
    true,
  ]

  const [requiredCompany, showCompany] = settingsMap.get(addLeadCompany) ?? [
    false,
    true,
  ]

  const theme = useTheme()

  return (
    <FormSection label="Lead Information" spacing={spacing}>
      {/* first name */}
      {showFirstName && (
        <>
          <Grid item xs md>
            <Field
              name="firstName"
              label="First Name"
              component={DebouncedTextField}
              required={requiredFirstName}
              disabled={disabled}
              inputProps={{ maxLength: 15 }}
            />
          </Grid>
        </>
      )}
      {/* last name */}
      {showLastName && (
        <>
          <Grid item xs md style={{ paddingLeft: theme.spacing(2) }}>
            <Field
              name="lastName"
              label="Last Name"
              component={DebouncedTextField}
              required={requiredLastName}
              disabled={disabled}
              inputProps={{ maxLength: 20 }}
            />
          </Grid>{' '}
        </>
      )}
      {/* company name */}
      {showCompany && (
        <Grid item xs={12}>
          <Field
            name="company"
            label="Company Name"
            component={DebouncedTextField}
            required={requiredCompany}
            disabled={disabled}
            inputProps={{ maxLength: 35 }}
          />
        </Grid>
      )}
    </FormSection>
  )
}
LeadInformation.displayName = 'LeadInformation'

export default React.memo(LeadInformation)
